import { useState } from "react";
import { ArrowRight, Check } from "lucide-react";

// Frontend-only early-access form: shows a success message on submit
// (no backend capture yet — per build decision).
export const EarlyAccessForm = ({ compact = false }) => {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = (e) => {
        e.preventDefault();
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
        if (!valid) {
            setError("Enter a valid email address.");
            return;
        }
        setError("");
        setDone(true);
    };

    if (done) {
        return (
            <div
                data-testid="early-access-success"
                className="card-surface flex items-center gap-3 p-4"
            >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-signal/15 text-signal">
                    <Check size={16} />
                </span>
                <p className="text-sm text-text-hi">
                    You're on the list. We'll keep you honest — and we'll keep
                    you posted.
                </p>
            </div>
        );
    }

    return (
        <form
            onSubmit={onSubmit}
            data-testid="early-access-form"
            className={`w-full ${compact ? "max-w-md" : "max-w-lg"}`}
            noValidate
        >
            <div className="flex flex-col gap-3 sm:flex-row">
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@email.com"
                    data-testid="early-access-email"
                    aria-label="Email address"
                    className="flex-1 rounded border border-haze bg-ink-soft px-4 py-3 font-mono text-sm text-text-hi placeholder:text-text-lo/60 focus:border-rule focus:outline-none focus:ring-1 focus:ring-rule"
                />
                <button
                    type="submit"
                    data-testid="early-access-submit"
                    className="btn-amber inline-flex items-center justify-center gap-2 rounded px-6 py-3 text-sm font-semibold"
                >
                    Request access <ArrowRight size={16} />
                </button>
            </div>
            {error && (
                <p
                    data-testid="early-access-error"
                    className="mt-2 font-mono text-xs text-warn"
                >
                    {error}
                </p>
            )}
            <p className="mt-3 font-mono text-[11px] text-text-lo">
                Currently in paper-trading evaluation. We'll tell you exactly
                when that changes.
            </p>
        </form>
    );
};

export default EarlyAccessForm;
